<template>
    <form @submit.prevent="startQuiz" class="homepage-form" accept-charset="UTF-8" @keypress.enter.prevent="startQuiz">
        <InputText
            v-if="!$store.getters.isLogin"
            name="email"
            type="email"
            v-model="email"
            placeholder="Adresse courriel"
            :error="errors['email'] ? errors['email'] : ''"
        />
        <div class="flex flex-row justify-center mt-12">
            <Btn
                type="submit"
                label="Débuter une évaluation"
                icon-after="arrow-right"
                bg-color="yellow"
            ></Btn>
        </div>
    </form>
</template>

<script>
import InputText from 'templates/objects/InputText';
import Btn from 'templates/objects/Btn';
import { isEmpty } from 'services/utils';
import types from 'store/types';
import { ROUTES } from 'config/routes';
import { validateErrorsForm } from 'services/validation';

export default {
    name: 'HomepageForm',
    components: {
        Btn,
        InputText,
    },
    data() {
        return {
            email: '',
            errors: {},
        };
    },
    created() {
        if (this.$store.getters.isLogin) {
            this.email = this.$store.state.user.currentUser.email;
            this.$store.dispatch(types.SET_EMAIL, this.$store.state.user.currentUser.email);
        }
    },
    methods: {
        startQuiz() {
            this.$store.dispatch(types.SET_EMAIL, this.email);
            this.errors = {};

            if (isEmpty(this.$store.state.quiz.email)) {
                this.errors.email = 'Veuillez saisir votre adresse courriel pour débuter l’évaluation';
                return;
            }

            const errors = validateErrorsForm({ email: this.$store.state.quiz.email }, ['email']);
            if (!isEmpty(errors)) {
                this.errors.email = errors.email;
                return;
            }

            // open modal to create quiz
            this.$router.push(ROUTES.MODAL.CREATE_QUIZ);
        },
    },
};
</script>
